import axios from 'axios'
import token from '@/storage/token.js'
import { mapActions, mapGetters } from 'vuex'

export default {
    created () {
        axios.defaults.headers.common['Authorization'] = token.getToken()
    },
    computed: {
        ...mapGetters('account', [
            'is_login',
            'account_info'
        ])
    },
    methods: {
        ...mapActions('account', [
            'action_login',
            'action_logout',
            'action_get_personal_info'
        ]),
    },
}